// Compute a valid select value.
// The options[].code is compared.
// Returns the current value if valid, otherwise the first in the list.
// If the list is empty than the empty string is returned.
export const computeSelectValue = (options, currentValue=null) => {
    if (options === null) return '';
    if (options.length === 0) return '';

    for (const option of options) {
        if (option.code === currentValue) return currentValue;
    }

    return options[0].code;
}